export default __webpack_public_path__ + "static/media/logo-animation2.d4cd06c2.gif";